import { type DataForParent, microFrontListener } from '@b2ag/micro-front-tools'
import { useAnalyticService } from '@b2ag/plugin-aladin-gtm'
import { useRouter } from 'vue-router'
import { callbacksFromCurrentProfileMicroFrontIframe } from '~/contexts/current-profile'

export const currentProfileRoutes = [
  {
    path: '/current-profile',
    name: 'current-profile',
    component: () => import('@b2ag/micro-front-current-profile/app'),
    props: () => ({
      microFrontName: 'current-profile',
      viewName: 'add-current-profile',
    }),
    beforeEnter() {
      const router = useRouter()
      microFrontListener({
        iframe: { href: window.location.origin },
        callbackForMessages: (data: DataForParent) => callbacksFromCurrentProfileMicroFrontIframe(data, router),
        router: useRouter() as any,
        analyticService: (() => useAnalyticService())(),
      })
    },
    meta: {
      private: true,
      layout: 'minimal',
    },
  },
]
